export default __webpack_public_path__ + "static/media/fifttyoffwitharc.c13c4259.svg";